export const properties = {

    state: {

        appBody: null,
        appScrollTop: 0,
        preventScroll: false
        
    },

    mutations: {

        setAppBody( state, appBody ) { state.appBody = appBody },
        setAppScrollTop( state, scrollTop ) { state.appScrollTop = scrollTop },
        setPreventScroll( state, preventScroll ) { state.preventScroll = preventScroll }

    },

    actions: {}

}